import { Globe, Check } from "lucide-react";
import { useCurrency } from "@/context/CurrencyContext";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuLabel, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";

export function CurrencySelector() {
  const { config, currency, changeCurrency, region } = useCurrency();
  const list = Object.entries(config.currencies || {});

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="currency-selector" className="flex items-center gap-1.5 rounded-full border border-white/10 bg-white/5 px-3 py-1.5 text-xs font-mono font-medium text-slate-200 transition-colors hover:border-[#00F0FF]/40 hover:text-[#00F0FF]">
          <Globe className="h-3.5 w-3.5" /> {currency}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56 border-white/10 bg-[#111420] text-slate-200">
        <DropdownMenuLabel className="font-mono text-[10px] uppercase tracking-wider text-slate-400">
          {region?.country ? `Detected: ${region.country}` : "Select Currency"}
        </DropdownMenuLabel>
        <DropdownMenuSeparator className="bg-white/10" />
        {list.map(([code, c]) => (
          <DropdownMenuItem key={code} data-testid={`currency-option-${code}`} onClick={() => changeCurrency(code)}
            className="flex items-center justify-between focus:bg-[#00F0FF]/10 focus:text-[#00F0FF] cursor-pointer">
            <span className="flex items-center gap-2"><span className="font-mono w-8">{c.symbol}</span> {code} · {c.name}</span>
            {currency === code && <Check className="h-4 w-4 text-[#00F0FF]" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
